import 'consumerweb-shim';
import 'adsinterceptor';
import React from 'react';

import { PayPalScriptProvider } from '@paypal/react-paypal-js';
import { Footer } from 'marketing-components';
import ReactDOM from 'react-dom';
import classNames from 'classnames';
import axios from 'axios';
import get from 'lodash/get';
import isEmpty from 'lodash/isEmpty';
import GroupDonation from '../components/groupDonation/groupDonation';
import HeroModule from '../components/HeroModule';
import LogoStrip from '../components/LogoStrip';
import Nav from '../components/Nav';
import Module from '../components/Module';
import SocialShare from '../components/SocialShare';
import Confirmation from '../components/confirmation';
import CheckoutError from '../components/checkoutError';
import styles from './multi-fundraiser.less';
import FeaturedCharityCardContainer from '../components/featuredCharityCardContainer/featuredCharityCardConatiner';
import { PAYPAL_THEME } from '@paypalcorp/pp-react';
import { ThemeProvider } from '@emotion/react';
import content from '../lib/i18n';
const i18n = content('multiCharityLanding');
import {
  CAMPAIGN_PAGE_GROUP,
  CAMPAIGN_MULTI_CHARITY_LANDING,
} from '../lib/fptiTrackingVariables';
import { DataContext } from '../lib/context';

function parseFPTI(fptiData) {
  const pairs =
    (decodeURIComponent(fptiData) && decodeURIComponent(fptiData).split('&')) ||
    [];
  const nameValues = pairs.reduce((reduced, current) => {
    const parts = current.split('=');
    reduced[parts[0]] = parts[1];
    return reduced;
  }, {});
  return nameValues;
}

class Page extends React.Component {
  constructor(props) {
    super(props);
    const numCharities = get(props, 'campaign.charities', []).length;

    const navNeeded =
      get(props, 'campaign.templateData.navAndLogoStrip.navNeeded', 'no') ===
      'yes';

    const initialState = {
      fptiInfo: {
        pgrp: CAMPAIGN_PAGE_GROUP,
        page: CAMPAIGN_MULTI_CHARITY_LANDING,
      },
      showHR: true,
      navNeeded,
      FB: {},
      isMobile: false,
      isTablet: false,
      numCharities,
      isFixed: false,
    };
    this.state = initialState;
  }

  componentDidMount() {
    let isMobile = false;
    let isTablet = false;

    let scrollDown, scrollTop;

    if (/Android|webOS|iPhone|IEMobile|Opera Mini/i.test(navigator.userAgent)) {
      isMobile = true;
      this.setState({
        showHR: false,
        isMobile,
      });
    }
    if (/iPad/i.test(navigator.userAgent)) {
      isTablet = true;
      this.setState({
        isTablet,
      });
    }

    if (this.state.navNeeded) {
      if (isMobile) {
        scrollDown = 704;
        scrollTop = 705;
      } else {
        const navBarElement = document
          .getElementById('nav_bar')
          .getBoundingClientRect();
        scrollDown = navBarElement.top;
        scrollTop = navBarElement.top + 1;
      }
    }

    // Adding CSRF token for all AJAX calls.
    axios.interceptors.request.use((config) => {
      config.headers = config.headers || {};
      config.headers = Object.assign({}, config.headers, {
        'X-CSRF-Token': this.props.csrf,
      });
      return config;
    });

    window.addEventListener(
      'scroll',
      this.handleScroll.bind(this, scrollDown, scrollTop)
    );
  }

  handleScroll = (scrollDown, scrollTop, event) => {
    event.preventDefault();
    if (window.scrollY > scrollDown) {
      this.setState({
        isFixed: true,
      });
    }

    if (window.scrollY < scrollTop) {
      this.setState({
        isFixed: false,
      });
    }
  };

  renderHero = () => {
    return (
      <HeroModule
        i18n={i18n}
        isMobile={this.state.isMobile}
        enable={this.props.campaign.state === 'ACTIVE'}
        isTablet={this.state.isTablet}
        campaignInfo={this.props.campaign}
        csrf={csrf}
        fptiInfo={this.state.fptiInfo}
        cdnHost={this.props.data.cdnHost}
        domain={this.props.data.domain}
      />
    );
  };

  renderNav = () => {
    if (this.state.navNeeded) {
      return (
        <div>
          <Nav
            i18n={i18n}
            charities={this.props.campaign.charities}
            templateData={this.props.campaign.templateData}
            isFixed={this.state.isFixed}
          />
        </div>
      );
    }
  };

  renderLogoStrip = () => {
    let logoStrip;

    const logoStripNeeded =
      get(
        this.props,
        'campaign.templateData.navAndLogoStrip.logoStripNeeded'
      ) === 'yes';
    if (logoStripNeeded) {
      logoStrip = (
        <LogoStrip
          numCharities={this.state.numCharities}
          campaignInfo={this.props.campaign}
          navNeeded={this.state.navNeeded ? 'yes' : 'no'}
          isFixed={this.state.isFixed}
        />
      );
    }
    return <div>{logoStrip}</div>;
  };

  renderHrLine = () => {
    return (
      <div>
        {this.state.numCharities > 1 && !this.state.isMobile && (
          <hr className='h-r h-r1' />
        )}
      </div>
    );
  };

  renderGroupDonation = () => {
    const giveToAGroupNeeded = get(
      this.props,
      'campaign.templateData.giveToAGroupNeeded',
      'no'
    );
    if (giveToAGroupNeeded === 'yes') {
      return (
        <GroupDonation
          id={'groupDonation'}
          isGroupDonation={true}
          i18n={i18n}
          enable={this.props.campaign.state === 'ACTIVE'}
          isMobile={this.state.isMobile}
          campaignInfo={this.props.campaign}
          csrf={csrf}
          fptiInfo={this.state.fptiInfo}
          cdnHost={this.props.data.cdnHost}
        />
      );
    }
  };

  renderFeaturedCardCharity = () => {
    let charities = this.props.campaign.charities;
    const charitiesModuleNeeded =
      get(
        this.props,
        'campaign.templateData.navAndLogoStrip.charitiesModuleNeeded'
      ) === 'yes';
    const charityModule = get(
      this.props,
      'campaign.templateData.donationModule'
    );
    const giveToAGroupNeeded = get(
      this.props,
      'campaign.templateData.giveToAGroupNeeded',
      'no'
    );
    const multiCharities = this.state.numCharities > 1;

    if (multiCharities && charitiesModuleNeeded) {
      return (
        <FeaturedCharityCardContainer
          charityModule={charityModule}
          gtgEnabled={giveToAGroupNeeded === 'yes'}
          charities={charities}
          i18n={i18n}
          isMobile={this.state.isMobile}
          isTablet={this.state.isTablet}
          enable={this.props.campaign.state === 'ACTIVE'}
          campaignInfo={this.props.campaign}
          csrf={csrf}
          fptiInfo={this.state.fptiInfo}
          cdnHost={this.props.data.cdnHost}
        />
      );
    }
  };

  renderAboutModules = () => {
    let aboutModule;
    const aboutNeeded =
      get(this.props, 'campaign.templateData.aboutSection.aboutNeeded') ===
      'yes';
    if (aboutNeeded) {
      const aboutTitle = get(
        this.props,
        'campaign.templateData.aboutSection.aboutTitle',
        ''
      );
      const aboutDesc = get(
        this.props,
        'campaign.templateData.aboutSection.aboutDesc',
        ''
      );
      aboutModule = (
        <Module
          id='campaign'
          className={`campaign ${styles.moduleStyle}`}
          info='module2'
          title={aboutTitle}
          desc={aboutDesc}
        />
      );
    }

    let ctaModule;
    const ctaNeeded =
      get(this.props, 'campaign.templateData.ctaSection.ctaNeeded') === 'yes';
    if (ctaNeeded) {
      const ctaTitle = get(
        this.props,
        'campaign.templateData.ctaSection.ctaTitle',
        ''
      );
      const ctaDesc = get(
        this.props,
        'campaign.templateData.ctaSection.ctaDesc',
        ''
      );
      ctaModule = (
        <Module
          id='about'
          className={`about ${styles.moduleStyle}`}
          info='module3'
          title={ctaTitle}
          desc={ctaDesc}
        />
      );
    }

    return (
      <div>
        {aboutModule}
        {ctaModule}
      </div>
    );
  };

  getConfirmationModalText = (confirmationDetails, campaignInfo) => {
    let title = get(confirmationDetails, 'confirmationTitle');
    if (isEmpty(title)) {
      title = i18n('label.conf-title');
    }
    let subTitle = get(confirmationDetails, 'confirmationSubTitle');
    if (isEmpty(subTitle)) {
      subTitle = i18n('label.conf-subTitle');
    }
    let buttonText = i18n('label.conf-done-button');
    let copyText = i18n('label.conf-copy-button');
    const confSocialNeeded =
      get(confirmationDetails, 'socialNeeded', 'yes') === 'yes';
    const socialShareNeeded =
      get(campaignInfo, 'templateData.socialShareNeeded', 'yes') === 'yes';
    try {
      const { personalization } = JSON.parse(
        document.getElementById('data-props').innerHTML
      );
      if (!isEmpty(personalization['conf-title'])) {
        title = personalization['conf-title'];
      }
      if (!isEmpty(personalization['conf-subTitle'])) {
        subTitle = personalization['conf-subTitle'];
      }
      if (!isEmpty(personalization['conf-buttonText'])) {
        buttonText = personalization['conf-buttonText'];
      }
      if (!isEmpty(personalization['conf-copyText'])) {
        copyText = personalization['conf-copyText'];
      }
    } catch (e) {
      // doSomething
    }
    return {
      title,
      subTitle,
      buttonText,
      copyText,
      inviteText: undefined,
      confSocialNeeded,
      socialShareNeeded,
    };
  };

  renderConfirmationPage = () => {
    const donated = get(this.props, 'campaign.donationInfo.donated');

    if (donated === 1) {
      const confirmationModalText = this.getConfirmationModalText(
        this.props.campaign.templateData.confirmation,
        this.props.data
      );
      return (
        <div data-ppvx_modal-id='campaignConfirmation'>
          <Confirmation
            i18n={i18n}
            campaignInfo={this.props.campaign}
            fptiInfo={this.state.fptiInfo}
            npid={this.props.campaign.donationInfo.npid}
            pageurl={this.props.data.eventUrl}
            cdnHost={this.props.data.cdnHost}
            title={confirmationModalText.title}
            subTitle={confirmationModalText.subTitle}
            buttonText={confirmationModalText.buttonText}
            copyText={confirmationModalText.copyText}
            confSocialNeeded={confirmationModalText.confSocialNeeded}
            socialShareNeeded={confirmationModalText.socialShareNeeded}
            campaignSocialShare
          />
        </div>
      );
    } else if (donated === 0) {
      return (
        <CheckoutError
          i18n={i18n}
          fptiInfo={this.state.fptiInfo}
          cdnHost={this.props.data.cdnHost}
        />
      );
    }
  };

  renderSocialShare = () => {
    const socialShareNeeded = get(
      this.props,
      'campaign.templateData.socialShareNeeded',
      'yes'
    );
    if (socialShareNeeded === 'yes') {
      return (
        <SocialShare
          FB={this.state.FB}
          campaignInfo={this.props.campaign}
          fptiInfo={this.state.fptiInfo}
        />
      );
    }
  };

  renderFooter = () => {
    const {
      content: { content: footerContent, config = {} },
    } = JSON.parse(document.getElementById('data-footer').innerHTML);
    const { localeCountry } = footerContent;

    return (
      <Footer
        config={config}
        content={footerContent}
        localeCountry={localeCountry}
      />
    );
  };

  renderPage = () => {
    const disasterLandingStyling = classNames('landingPage_viewport', {
      singleCharity: this.state.numCharities === 1,
    });

    return (
      <div>
        <div className={disasterLandingStyling}>
          {this.renderHero()}
          {this.renderNav()}
          {this.renderLogoStrip()}
          {this.renderHrLine()}
        </div>
        {this.renderConfirmationPage()}
        {this.renderGroupDonation()}
        {this.renderFeaturedCardCharity()}
        {this.renderAboutModules()}
        {this.renderSocialShare()}
        {this.props.mppFooter && this.renderFooter()}
      </div>
    );
  };

  render() {
    if (this.props.campaign && this.props.campaign.isVenmo) {
      let sdkBaseURL;
      if (this.props.campaign.isLive) {
        sdkBaseURL = 'https://www.paypal.com/sdk/js';
      } else {
        sdkBaseURL = 'https://www.msmaster.qa.paypal.com/sdk/js';
      }

      return (
        <PayPalScriptProvider
          options={{
            sdkBaseURL,
            'client-id': this.props.campaign.clientID,
            'enable-funding': 'venmo',
          }}
        >
          {this.renderPage()}
        </PayPalScriptProvider>
      );
    } else {
      return this.renderPage();
    }
  }
}

const deviceType = JSON.parse(
  document.getElementById('data-deviceType').innerHTML
);
const data = JSON.parse(document.getElementById('data-props').innerHTML);
const mppFooter = data.mppFooter;
const csrf = document.getElementById('data-csrf').innerHTML;
const campaign = JSON.parse(document.getElementById('data-props').innerHTML);
const fptiInfo = JSON.parse(
  document.getElementById('data-fpti-info').innerHTML
);

ReactDOM.render(
  <DataContext.Provider value={data}>
    <ThemeProvider theme={PAYPAL_THEME}>
      <Page
        deviceType={deviceType}
        csrf={csrf}
        campaign={campaign}
        fptiInfo={fptiInfo}
        data={data}
        mppFooter={mppFooter}
      />
    </ThemeProvider>
  </DataContext.Provider>,
  document.getElementById('Page')
);
